import { useRoutes, Navigate } from 'react-router-dom';
import { useStore } from '../store';
import Layout from "../components/layout";
// Modules
// Internal
import Overview from "../modules/overview";
import Company from '../modules/company';
import Employees from '../modules/employees';
import CreateEmployee from '../modules/employees/create';
import ViewEmployee from '../modules/employees/view';
import HistoryEmployee from '../modules/employees/history';

import Attendance from '../modules/attendance';
import CreateAttendance from '../modules/attendance/new';
import Error404 from '../modules/errors/404';
import Communication from '../modules/communication';
import ViewCommunication from '../modules/communication/view';
import Leaves from '../modules/leaves';
import ViewLeave from '../modules/leaves/view';
import NewLeave from '../modules/leaves/new';

import Support from '../modules/support';
import NewSupport from '../modules/support/new';
import ViewSupport from '../modules/support/view';

// External
import Login from '../modules/user/login';
import SignUp from '../modules/user/signUp';
import PasswordReset from '../modules/user/passwordReset';
import RequestReset from '../modules/user/requestReset';
import PastEmployees from '../modules/pastEmployees';
// import PastCreateEmployee from '../modules/pastEmployees/create';
import PastViewEmployee from '../modules/pastEmployees/view';
import HistoryLeaveSettings from '../modules/employees/historyLeaveSettings';
import HistoryPastEmployee from '../modules/pastEmployees/history';
import HistoryLeaveSettingsPastEmployee from '../modules/pastEmployees/historyLeaveSettings';

const AppRoutes = () => {
    const { layoutStore } = useStore();
    const renderDash = (element) => {
        return (<Layout>{element}</Layout>);
    };
    const defaultRoutes = [{ path: '/404', element: <Error404 /> }];
    const publicRoutes = [
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '/get-started',
            element: <SignUp />
        },
        {
            path: '/',
            element: <Navigate to="/login" />
        },
        {
            path: '/password-reset/:token',
            element: <PasswordReset />
        },
        {
            path: '/password-reset',
            element: <RequestReset />
        },
        {
            path: '*',
            element: <Navigate to="/login" />
        }
    ];
    const privateRoutes = [
        {
            path: '/overview',
            element: renderDash(<Overview />)
        },
        {
            path: '/company',
            element: renderDash(<Company />)
        },
        {
            path: '/employees',
            element: renderDash(<Employees />)
        },
        {
            path: '/past-employees',
            element: renderDash(<PastEmployees />)
        },
        {
            path: '/employees/create',
            element: renderDash(<CreateEmployee />)
        },
        {
            path: '/employees/edit/:id',
            element: renderDash(<CreateEmployee />)
        },
        // {
        //     path: '/past-employees/edit/:id',
        //     element: renderDash(<PastCreateEmployee />)
        // },  
        {
            path: '/employees/history/:id',
            element: renderDash(<HistoryEmployee />)
        },
        {
            path: '/past-employees/history/:id',
            element: renderDash(<HistoryPastEmployee />)
        },
        {
            path: '/employees/history-leave-settings/:id',
            element: renderDash(<HistoryLeaveSettings />)
        },
        {
            path: '/past-employees/history-leave-settings/:id',
            element: renderDash(<HistoryLeaveSettingsPastEmployee />)
        },
        {
            path: '/employees/:id',
            element: renderDash(<ViewEmployee />)
        },
        {
            path: '/past-employees/:id',
            element: renderDash(<PastViewEmployee />)
        },
        {
            path: '/leaves',
            element: renderDash(<Leaves />)
        },
        {
            path: '/leaves/new',
            element: renderDash(<NewLeave />)
        },
        {
            path: '/leaves/:id',
            element: renderDash(<ViewLeave />)
        },
        {
            path: '/attendance',
            element: renderDash(<Attendance />)
        },
        {
            path: '/attendance/new',
            element: renderDash(<CreateAttendance />)
        },
        {
            path: '/communication',
            element: renderDash(<Communication />)
        },
        {
            path: '/communication/:id',
            element: renderDash(<ViewCommunication />)
        },
        {
            path: '/support',
            element: renderDash(<Support />)
        },
        {
            path: '/support/new',
            element: renderDash(<NewSupport />)
        },
        {
            path: '/support/:id',
            element: renderDash(<ViewSupport />)
        },
        {
            path: '/',
            element: <Navigate to="/overview" />
        },
        {
            path: '/login',
            element: <Navigate to="/overview" />
        },
        {
            path: '/get-started',
            element: <Navigate to="/overview" />
        },
        {
            path: '/password-reset/:token',
            element: <Navigate to="/overview" />
        },
        {
            path: '/password-reset',
            element: <Navigate to="/overview" />
        },
        {
            path: '*',
            element: <Navigate to="/404" />
        }
    ]
    const is_authenticated = layoutStore.isLoggedIn;
    const routes = useRoutes([
        ...(is_authenticated ? privateRoutes : publicRoutes),
        ...defaultRoutes
    ]);
    return routes;
}
export default AppRoutes;